import { inject, observer } from "mobx-react";
import SettingEtcPrinterSetItemView from "./SettingEtcPrinterSetItemView";
import SettingEtcPrinterSetItemAddView from "./SettingEtcPrinterSetItemAddView";
import {
  fn_setPrintSettingFlag,
  fn_getPrintSettingFlag,
  fn_getKitchenPrintSettingFlag,
  fn_setKitchenPrintSettingFlag,
} from "function/FnBodySetting";
import { SectionTitle } from "components/ui/SectionTitle";
import { Switcher } from "components/ui/Switcher";
import InfoPanel from "components/ui/InfoPanel";
import { Button } from "components/ui/Button";
import bgAdd from "static-file/images/bg_add.png";
interface PrinterSettingItem {
  baudRate: string;
  customerSheet: number;
  index: number;
  portNo: string;
  posNo: string;
  printerCode: string;
  printerName: string;
  shopSheet: number;
  type: string;
  useYn: string;
}
const SettingEtcPrinterSetView = ({ rootStore }: { rootStore: any }) => {
  const { settingStore, searchStore, modalStore } = rootStore;
  const { getPrinterInfo, getEtcPrinterInfo, getMainPosType } = settingStore;

  const { printList, printListKitchens } = (() => {
    const defaultPrints: PrinterSettingItem[] = getEtcPrinterInfo.defaultPrintSettings || [];
    return defaultPrints.reduce(
      (acc, printer) => {
        if (printer.portNo !== "COM0") {
          if (printer.type === "01") {
            acc.printList.push(printer);
          } else {
            acc.printListKitchens.push(printer);
          }
        }
        return acc;
      },
      { printList: [] as PrinterSettingItem[], printListKitchens: [] as PrinterSettingItem[] }
    );
  })();

  const printAddList: PrinterSettingItem[] = getEtcPrinterInfo.addPrintSettings || [];
  const isPrintListEmpty = printList.length === 0 && printAddList.length === 0;

  // 프린터 추가 버튼
  const AddPrintButton = () => (
    <Button variant="default" className="!w-[335px] !h-[48px]" onClick={() => modalStore.openModal("printAdd", {})}>
      <img src={bgAdd} alt="프린터 추가하기" />
      <span>프린터 추가하기</span>
    </Button>
  );

  // 영수 프린터 설정 리스트
  const PrinterListView = () => {
    if (getPrinterInfo.etcPrinterFlag === "N") {
      return <InfoPanel variant="smile" title="배달앱 전표를 출력할 영수프린터를 설정하세요" />;
    }

    if (getPrinterInfo.etcPrinterFlag === "Y" && isPrintListEmpty) {
      return (
        <InfoPanel
          variant="smile"
          title="포스에 등록된 영수프린터가 없어요"
          subtitle="[프린터 추가하기] 를 통해 프린터를 추가해보세요"
          children={<AddPrintButton />}
        />
      );
    }

    return (
      <div className="box_cont setting w-full !flex justify-center">
        <div className="flex flex-col w-full gap-4 items-center pb-8">
          <ul className="list_print w-full !m-0 !border-none">
            {printList?.map((obj, index) => (
              <SettingEtcPrinterSetItemView key={index} rootStore={rootStore} obj={obj} index={obj.index} />
            ))}
            {printAddList?.map((obj, index) => (
              <SettingEtcPrinterSetItemAddView key={index} rootStore={rootStore} obj={obj} index={index} />
            ))}
          </ul>
          <AddPrintButton />
        </div>
      </div>
    );
  };

  // 주방 프린터 설정 리스트
  const KitchenPrinterListView = () => {
    // 1. 프린터 설정을 사용하지 않는 경우
    if (getPrinterInfo.etcKitchenPrinterFlag === "N") {
      return <InfoPanel variant="smile" title="배달앱 전표를 출력할 주방프린터를 설정하세요" />;
    }

    // 2. 설정은 사용하지만, 등록된 프린터가 없는 경우
    if (printListKitchens.length === 0) {
      return (
        <InfoPanel
          variant="smile"
          title="웹정보(ASP)에 설정된 주방프린터가 없어요"
          subtitle="주방프린터 추가는 관리 대리점에 문의해주세요"
        />
      );
    }

    // 3. 등록된 프린터 목록이 있는 경우
    return (
      <ul className="list_print w-full !m-0 !border-none">
        {printListKitchens.map((obj, index) => (
          <SettingEtcPrinterSetItemView key={index} rootStore={rootStore} obj={obj} index={obj.index} />
        ))}
      </ul>
    );
  };

  return (
    <div className="scroll tab">
      <div className="inner">
        <div className="wrap_connect print">
          <SectionTitle
            title="영수프린터 설정"
            subTitle="연동 주문 접수 시, 배달전표 출력 영수프린터 설정"
            addBottomBorder
          >
            <Switcher
              id="checkbox1"
              size="lg"
              switcherColor="primary"
              checked={getPrinterInfo.etcPrinterFlag === "Y"}
              onChange={() => fn_setPrintSettingFlag(rootStore, !fn_getPrintSettingFlag(rootStore))}
              showLabel={true}
              onLabel="사용"
              offLabel="미사용"
            />
          </SectionTitle>
          {/* 영수프린터 설정 리스트 */}
          <div className="min-h-[250px] flex justify-center">{PrinterListView()}</div>

          {/* 주방프린터 설정 리스트 */}
          <div className="box">
            {getMainPosType === "Y" ? (
              <>
                <SectionTitle
                  title="주방프린터 설정"
                  subTitle="연동 주문 접수 시, 배달전표 출력 주방프린터 설정"
                  addBottomBorder
                >
                  <Switcher
                    id="checkbox2"
                    size="lg"
                    switcherColor="primary"
                    checked={getPrinterInfo.etcKitchenPrinterFlag === "Y"}
                    onChange={() => fn_setKitchenPrintSettingFlag(rootStore, !fn_getKitchenPrintSettingFlag(rootStore))}
                    showLabel={true}
                    onLabel="사용"
                    offLabel="미사용"
                  />
                </SectionTitle>

                <div className="box_cont setting min-h-[250px] w-full !flex justify-center">
                  {KitchenPrinterListView()}
                </div>
              </>
            ) : (
              <>
                <SectionTitle
                  title="주방프린터 설정"
                  subTitle="연동 주문 접수 시, 배달전표 출력 주방프린터 설정"
                  addBottomBorder
                />
                <InfoPanel
                  variant="smile"
                  title="메인포스에서 설정해 주세요"
                  subtitle={`현재 사용중인 포스는 ${searchStore.getSession.connPosNo}번 포스입니다`}
                  className="min-h-[180px]"
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject("rootStore")(observer(SettingEtcPrinterSetView));
